export default __webpack_public_path__ + "static/media/mediterraneansnack@3x.aded50fb.jpg";